import { ITavusPersona, ITavusPersonaFormik } from 'entities/tavus/persona';
import { Settings } from './Settings';
import { FormikProps } from 'formik';
import { FC } from 'react';

interface IProps {
  formik: FormikProps<ITavusPersonaFormik>;
  persona: ITavusPersona;
}
export const WidgetForm: FC<IProps> = ({ formik, persona }) => {
  return (
    <form onSubmit={formik.handleSubmit} className="ag-h-full ag-max-h-full">
      <div className="ag-h-full">
        <Settings persona={persona} formik={formik} />
      </div>
    </form>
  );
};
